const escapeEntityRE = /[&<>]/g;
const escapeEntityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;'
};

const escapeEntity = (entity) => escapeEntityMap[entity];

const CURRENCY_SIGN = {
  jpy: '¥',
  usd: '$'
};

const CURRENCY_DIGITS = {
  jpy: 0,
  usd: 2
};

export default {
  // 改行コードを<br>に変換します
  // @params {String} text 文字列
  // @returns {String} 変換されたHTML
  nl2br(text) {
    return String(text).replace(/\n/g, '<br>');
  },

  // 長い文字列を指定された文字数で省略します
  // @params {String} text
  // @params {Integer} length 省略させたい文字数
  // @params {String} omission 省略時に使用する文字列 default: '...'
  // @returns {String} 省略した文字列
  truncate(text, length, omission = '...') {
    if (text.length <= length) {
      return text;
    }
    return text.substring(0, length) + omission;
  },

  // escape
  // 文字列からエンティティ参照の表記に変換します
  // @params {String} text
  // @returns {String} 変換した文字列
  escapeEntity,
  escape(text) {
    return String(text).replace(escapeEntityRE, escapeEntity);
  },

  // 通貨の表記に変換します
  // 12345 => $12,345.00
  // @param {Number or String} value
  // @param {String} currency 通貨コード
  currency: function (value, currency = 'USD') {
    value = parseFloat(value);
    if (!isFinite(value) || (!value && value !== 0)) {
      return '';
    }
    if (Intl && Intl.NumberFormat) {
      return Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency.toUpperCase()
      }).format(value);
    }

    // IE 10 以下
    value = value.toFixed(CURRENCY_DIGITS[currency.toLowerCase()] || 0);
    while (value !== (value = value.replace(/^(-?)(\d+)(\d{3})/, '$1$2,$3')));
    return (CURRENCY_SIGN[currency.toLowerCase()] || '') + value;
  },

  // Boolean を表す文字列から判別して Boolean を返す
  toBoolean(str) {
    if (str === undefined) {
      return false;
    }
    switch (str) {
      case 'true':
      case '1':
      case 'on':
        return true;
      case 'false':
      case '0':
      case 'off':
        return false;
      default:
        try {
          return Boolean(JSON.parse(str));
        } catch (e) {
          return false;
        }
    }
  },

  // 文字列を指定した区切り文字で配列に変換します
  // @param {String} str
  // @param {String} separator default: ','
  stringToArray(str, separator = ',') {
    if (!str) {
      return [];
    }
    return str.split(separator).map((s) => s.trim());
  }
};

/**
 * Make str to Title Cased string.
 * @param {string} str
 * @returns {string}
 */
export function titleCase(str) {
  let result = str.replace(/(?![a-z]|[A-Z]|[0-9])./g, ' ');
  const words = result
    .split(' ')
    .filter((s) => s.length)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase());
  return words.join(' ');
}
